import { Fragment} from 'react';
import { Col, Row, Breadcrumb, Tab, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// import settings component
import ProfileGeneral from './general/ProfileGeneral';
import APICredentials from './api-credentials/APICredentials';

const AllProfile = () => {
	const { t } = useTranslation(); // useTranslation-Hook
	return (
		<Fragment>
			<Row>
				<Col>
					<Row>
						<Col lg={12} md={12} sm={12}>
							<div className="border-bottom pb-4 mb-4 d-md-flex align-items-center justify-content-between">
								<div className="mb-3 mb-md-0">
									<h1 className="mb-1 h2 font-weight-bold">{t('Profile')}</h1>
									<Breadcrumb>
										<Breadcrumb.Item href="#">{t('Dashboard')}</Breadcrumb.Item>
										<Breadcrumb.Item active>{t('Profile')}</Breadcrumb.Item>
									</Breadcrumb>
								</div>
							</div>
						</Col>
					</Row>
					<Tab.Container id="left-tabs-settings" defaultActiveKey="general">
						<Row>
							<Col lg={2} md={12}>
								<Nav variant="pills" className="flex-column">
									<Nav.Item>
										<Nav.Link eventKey="general"><i className="fe fe-briefcase me-2"></i> {t('General')}</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link eventKey="api-credentials"><i className="fe fe-command me-2"></i> {t('REST-API Credentials')}</Nav.Link>
									</Nav.Item>
								</Nav>
							</Col>
							<Col lg={10} md={12} className="mt-3 mt-lg-0">
								<Tab.Content>
									<Tab.Pane eventKey="general">
										<ProfileGeneral />
									</Tab.Pane>
									<Tab.Pane eventKey="api-credentials">
										<APICredentials />
									</Tab.Pane>
								</Tab.Content>
							</Col>
						</Row>
					</Tab.Container>
				</Col>
			</Row>
		</Fragment>
	);

};

export default AllProfile;